// Module
var code = "<ul> <li>American Education Services, 1200 N. 7th St., Harrisburg, PA | <a href=\"/contactUsMailFax\" target=\"_blank\">View\tMailing\tAddress</a> | <span class=\"nowrap\">1-800-233-0557</span> </li> <li><a href=\"/nevada\">Information for Nevada borrowers.</a></li> </ul> ";
// Exports
export default code;